<template>
  <Walkthrough 
    roomName="Gefängniszelle"
    roomKey="jailcell"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="german"
  />
</template>
<script>

export default {
  name: 'Celda',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/jailcell-1920x1280.jpg",
      steps: [
            "Blicke nach unten und inspiziere den Fußboden. Du solltest unter einem losen Ziegel einen Schraubenschlüssel finden.",
            "Blicke nach rechts und inspiziere den Spiegel. Du solltest dort versteckt eine alte Nagelfeile finden.",
            "Blicke nach vorne und inspiziere das Bett. Du solltest darunter Gefängniskleidung finden.",
            "Wende jetzt die Nagelfeile auf das Bett an. Du kannst damit etwas Farbe abkratzen und darunter Zeichnungen von einem Spiegel, einem Waschbecken,",
            "einer Tür und einer Lüftung vorfinden.",
            "Inspiziere mit immer noch nach vorne gerichtetem Blick das Kopfkissen. Du solltest dort eine Klinge finden, die später praktisch ist. Vergiss auf keinen Fall,",
            "sie mitzunehmen.",
            "Die Bilder auf dem Bett waren in Wirklichkeit Hinweise. Aus der Richtung, in der diese Gegenstände in der Zelle zu finden sind, erkennst du, wie du den",
            "Schraubenschlüssel drehen musst. Blicke nach rechts und wende den Schraubenschlüssel auf das Rohr an. Dreh ihn nach rechts, rechts, links und dann nach oben. Dadurch sollte das Wasser zurück in die Zelle fließen.",
            "Blicke bei fließendem Wasser wieder nach vorne und stopfe die Gefängniskleidung in die Toilette.",
            "Nutze die Toilette erneut, während die Gefängniskleidung in ihr steckt. Jetzt fließt das Wasser über und das steigende Wasser bringt dich an die Lüftung, die du mit der Klinge öffnen und ins Freie gelangen kannst. Herzlichen Glückwunsch, du bist entkommen. Probier den nächsten Raum alleine zu lösen! ",
        ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/walkthrough/de/jailcell.vue